import { AppThunkAction } from '../store';
import * as ActionTypes from "../common/ActionTypes";
import { KnownAction } from '../store/loanUpdateResponseStore';

export const loanUpdateResponseActionCreators = {
    setIsEncompassDown: (isEncompassDown?: boolean): AppThunkAction<KnownAction> => (dispatch) => {
        dispatch({ type: ActionTypes.SetIsEncompassDown, isEncompassDown: isEncompassDown});
    }
}